import { render, staticRenderFns } from "./FormPurchase.vue?vue&type=template&id=728cb750&"
import script from "./FormPurchase.vue?vue&type=script&lang=ts&"
export * from "./FormPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports